import { render, staticRenderFns } from "./description.vue?vue&type=template&id=117e743a&scoped=true"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=117e743a&prod&lang=scss&scoped=true&external"
import style1 from "./description.vue?vue&type=style&index=1&id=117e743a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e743a",
  null
  
)

export default component.exports